import React, { useState, useEffect } from "react"
import { SingleDatePicker } from "react-dates"
import moment from "moment"

import "react-dates/initialize"

/** Calendar component */
const Calendar = (props) => {
    const initialCurrentDate = moment(props.centered_date)
    const [date, setDate] = useState(initialCurrentDate)
    const [focus, setFocus] = useState(false);

    // https://reactjs.org/docs/hooks-effect.html
    // Dispatch other component state updates every time it gets updated
    useEffect(() => {
        window.dispatchEvent(new Event('resize_schedule_map'));
    })
    // Dispatch other component state updates once the component is fully rendered
    // https://www.pluralsight.com/guides/event-listeners-in-react-components
    useEffect(() => {
        window.addEventListener('change_date', handleChangeDates);

        // cleanup this component
        return () => {
            window.removeEventListener('change_date', handleChangeDates);
        };
    }, []);

    const handleChangeDates = (event) => {     
        if (event.detail.centeredDate) {
            let newCenteredDate = moment(event.detail.centeredDate, "YYYY-MM-DD")
            setDate(newCenteredDate)
        }
    };

    /** Event when input dates change */
    const onDateChange = (date) => {
        setDate(date)
        updateScheduleMap(date)
    }

    /** Update schedule map */
    function updateScheduleMap(centeredDate) {
        const dayFields = document.querySelectorAll(props.date_field_name)
        dayFields.forEach(function(ele) {
            ele.value = centeredDate.format('YYYY-MM-DD')
        });
        const submit_button = document.getElementById(props.submit_button)
        if(submit_button) {
            submit_button.click();
        }
    }

    /** Calendar information component for datepicker popup */
    const CalendarInfo = () => {
        return ""
    }

    return (
        <div className="calendar-date-select">
            <SingleDatePicker
                date={date}
                id="currentDateSelector"
                onDateChange={onDateChange}
                focused={focus}
                onFocusChange={({ focused }) => setFocus(focused)}
                numberOfMonths={1}
                orientation="horizontal"
                renderCalendarInfo={CalendarInfo}
                keepOpenOnDateSelect={false}
                hideKeyboardShortcutsPanel={true}
                showClearDate={false}
            />
        </div>
    )
}

export default Calendar
